<section id="sticky-header">
    <div class="wrapper" #errorMessageDiv>
        <div *ngIf="submitted && inventoryAdjForm.errors?.invalid"
            class="alert alert-danger alert-dismissible fade show server-error">
            <strong>Error!</strong> {{inventoryAdjForm.errors?.invalid}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        <div *ngIf="isInventoryFormSubmitted && inventoryAdjLotListForm.errors?.invalid"
            class="alert alert-danger alert-dismissible fade show server-error" #errorMessageDiv>
            <strong>Error!</strong> {{inventoryAdjLotListForm.errors?.invalid}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        <div *ngIf="isInventoryFormSubmitted && isSaved && inventoryAdjForm.valid"
            class="alert alert-success alert-dismissible fade show server-error" #successMessageDiv>
            <strong>Success!</strong> Saved Successfully!.
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
    </div>
</section>

<section class="wrapper edit-page">
    <div class="tracker-info-form">
        <h4 class="form-title">Inventory Adjustments</h4>
        <div class="responsive-grid">
            <form [formGroup]="inventoryAdjForm">
                <div class="grid-row clearfix">
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            CUSTOMER
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="customer" placeholder="">
                        </div>
                        <div *ngIf="submitted && inventoryAdjForm.controls.customer.errors" class="invalid-feedback">
                            <div *ngIf="inventoryAdjForm.controls.customer.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STATE
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="state" placeholder="">
                        </div>
                        <div *ngIf="submitted && inventoryAdjForm.controls.state.errors" class="invalid-feedback">
                            <div *ngIf="inventoryAdjForm.controls.state.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STORE/MODEL
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="store" placeholder="">
                        </div>
                        <div *ngIf="submitted && inventoryAdjForm.controls.store.errors" class="invalid-feedback">
                            <div *ngIf="inventoryAdjForm.controls.store.errors.required">This is required</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="mt-25 align-right pb-20 mb-20">
        <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
        <button class="btn btn-primary ml-10" (click)="fetchLotIds()">Get LOT IDs</button>
    </div>

    <div class="tracker-info mt-25 clearfix" *ngIf="lotList.length > 0 && isLotDataReady">
        <div class="pull-left info-col">
            <h4 class="info-title">Lot IDs</h4>
            <form [formGroup]="inventoryAdjLotListForm">
                <ng-container formArrayName="lotListArray">
                    <mat-accordion>

                        <mat-expansion-panel *ngFor="let lotdata of lotList;let rowIndex=index"
                            (opened)="lotdata.panelOpenState = true" (closed)="lotdata.panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{lotdata?.lotNumber}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="responsive-grid">
                                <form [formGroup]="getGroup(rowIndex)">
                                    <div class="tracker-info-form">
                                        <ng-container formArrayName="inventoryMasterReassignRecordDtoList">
                                            <ng-container
                                                *ngFor="let size of lotdata?.inventoryMasterReassignRecordDtoList; let i=index">
                                                <div [formGroupName]="i" class="grid-row clearfix">
                                                    <div class="col-25">
                                                        <label for="" class="field-label">
                                                            DIM1
                                                        </label>
                                                        <div class="relative">
                                                            <input type="text" class="form-control"
                                                                [ngClass]="{'disabled': true}" [readonly]="true"
                                                                formControlName="dim1" placeholder="">
                                                        </div>
                                                    </div>
                                                    <div class="col-25">
                                                        <label for="" class="field-label">
                                                            DIM2
                                                        </label>
                                                        <div class="relative">
                                                            <input type="text" class="form-control"
                                                                [ngClass]="{'disabled': true}" [readonly]="true"
                                                                formControlName="dim2" placeholder="">
                                                        </div>
                                                    </div>
                                                    <div class="col-25">
                                                        <label for="" class="field-label">
                                                            QUANTITY
                                                        </label>
                                                        <div class="relative">
                                                            <input type="text" class="form-control"
                                                                formControlName="qty" placeholder="">
                                                        </div>
                                                        <div class="invalid-feedback">
                                                            <div
                                                                *ngIf="checkSizeDetailsErrors('qty', 'qtyReasonCodeRequired', rowIndex, i)">
                                                                Please enter Quantity and ReasonCode together</div>
                                                            <div
                                                                *ngIf="checkSizeDetailsErrors('qty', 'pattern', rowIndex, i)">
                                                                Model quantity must be
                                                                numeric</div>
                                                        </div>
                                                    </div>

                                                    <div class="col-25">
                                                        <label for="" class="field-label">
                                                            REASON CODE
                                                        </label>                                                        
                                                        <div class="relative">
                                                            <select formControlName="reasonCode" class="form-control">
                                                                <option *ngFor="let type of reasonCodes" [ngValue]="type.value">{{type.name}}</option>
                                                            </select>
                                                        </div>
                                                        <div class="invalid-feedback">
                                                            <div
                                                                *ngIf="checkSizeDetailsErrors('reasonCode', 'required', rowIndex, i)">
                                                                This is required</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </form>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </ng-container>
            </form>
        </div>
        <div class="mt-25 align-right pb-20 mb-20">
            <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
            <button class="btn btn-primary ml-10" (click)="updateInventoryAdjustments()">Update</button>
        </div>
    </div>
</section>